<template>
    <a-drawer
        title="颜色主题切换"
        placement="right"
        v-model:visible="visible"
        :width="300"
    >   
    <!-- 颜色主题切换注释 -->
        <!-- <template #handle>
            <div class="setting-drawer-handle" @click="visible=true">
                <CloseOutlined v-if="visible"/>
                <SettingOutlined v-else/>
            </div>
        </template> -->
        <a-radio-group v-model:value="value" @change="onThemeChange">
            <a-radio v-for="(item,index) in colorList" :value="item.color" :key="index"
                     :style="{display:'block',lineHeight:'36px'}">
                <a-tag :color="item.color">{{ item.key }}</a-tag>
            </a-radio>
        </a-radio-group>
    </a-drawer>
</template>

<script>
import {ref} from "vue";
import themeConfig from "@/config/themeConfig";

export default {
    name: "SettingDrawer",
    setup() {
        const visible = ref(false);
        const value = ref(sessionStorage.getItem('themeColor') || '#1890FF');
        const colorList = [
            {key: '薄暮', color: '#F5222D'},
            {key: '火山', color: '#FA541C'},
            {key: '日暮', color: '#FAAD14'},
            {key: '明青', color: '#13C2C2'},
            {key: '极光绿', color: '#52C41A'},
            {key: '拂晓蓝（默认）', color: '#1890FF'},
            {key: '极客蓝', color: '#2F54EB'},
            {key: '酱紫', color: '#722ED1'}
        ]
        themeConfig.updateTheme(value.value);

        const onThemeChange = (e) => {
            sessionStorage.setItem('themeColor', e.target.value);
            themeConfig.updateTheme(e.target.value);
        }

        return {
            visible,
            value,
            colorList,
            onThemeChange,
        };
    }
}
</script>

<style scoped lang="less">
.setting-drawer-handle {
    position: absolute;
    top: 240px;
    right: 300px;
    z-index: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    font-size: 16px;
    text-align: center;
    background: #1890ff;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    pointer-events: auto;
    color: #ffffff;
}
</style>
